import React from "react";
import SectionHeader from "@/components/shared/SectionHeader";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { EISG_IMG } from "@/lib/data";
import { useI18n } from "@/lib/i18n";

const BDAdvisory = () => {
  const { t } = useI18n();
  return (
    <div>
      <section className="relative py-32 lg:py-40 overflow-hidden bg-[#0A192F] text-white grain">
        <div className="absolute inset-0 opacity-30">
          <img src={EISG_IMG.boardroom} alt="" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-r from-[#0A192F] via-[#0A192F]/85 to-transparent" />
        </div>
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 relative">
          <div className="overline text-[#D4AF37] mb-6">{t("adv.hero.eyebrow")}</div>
          <h1 className="font-bd text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight leading-[1.02] max-w-4xl">
            {t("adv.hero.title.a")} <br />{t("adv.hero.title.b")}
          </h1>
          <p className="mt-8 text-lg sm:text-xl text-white/75 max-w-3xl leading-relaxed">
            {t("adv.hero.body")}
          </p>
        </div>
      </section>

      <section className="py-24 lg:py-32 bg-white">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-16">
          <div className="lg:col-span-5">
            <SectionHeader number={t("adv.engagement.number")} eyebrow={t("adv.engagement.eyebrow")} title={t("adv.engagement.title")} />
            <div className="mt-10 space-y-6">
              {[0, 1, 2].map((i) => (
                <div key={i} className="border-l-2 border-[#D4AF37] pl-5 py-1">
                  <div className="overline text-[#0A192F]/60">— 0{i + 1}</div>
                  <h4 className="font-bd text-xl text-[#0A192F] mt-1">{t(`adv.engagement.${i}.label`)}</h4>
                  <p className="text-[#0A192F]/70 text-sm mt-1 leading-relaxed">{t(`adv.engagement.${i}.desc`)}</p>
                </div>
              ))}
            </div>
          </div>
          <div className="lg:col-span-7">
            <SectionHeader number={t("adv.coverage.number")} eyebrow={t("adv.coverage.eyebrow")} title={t("adv.coverage.title")} />
            <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-px bg-[#0A192F]/10">
              {[0, 1, 2, 3, 4, 5, 6, 7].map((i) => (
                <div key={i} className="bg-white p-6 lift-card">
                  <div className="section-num text-sm">— {String(i + 1).padStart(2, "0")}</div>
                  <p className="mt-3 font-bd text-lg text-[#0A192F]">{t(`adv.services.${i}`)}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-[#FAFAFA] border-t border-[#0A192F]/10">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 flex flex-col lg:flex-row items-start lg:items-center justify-between gap-8">
          <h3 className="font-bd text-3xl sm:text-4xl text-[#0A192F] tracking-tight max-w-2xl font-bold">
            {t("adv.cta.title")}
          </h3>
          <Link to="/contact" className="btn-premium btn-premium-primary">
            {t("adv.cta.btn")} <ArrowRight size={16} />
          </Link>
        </div>
      </section>
    </div>
  );
};

export default BDAdvisory;
